import UIHashBaseContainer from './UIHashBaseContainer';

export default class UIHashGroupContainer extends UIHashBaseContainer {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _nextItems: any;
    constructor() {
        super();
        this._nextItems = [];
    }
    get nextItems() {
        return this._nextItems;
    }
    addNextItem(item) {
        this._nextItems.push(item);
    }
}
